var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-header"},[_c('div',{staticClass:"tag-pill"},[_c('span',{staticClass:"blink-dot"}),_vm._v(" faq --list ")]),_c('h1',{staticClass:"title"},[_vm._v("Frequently Asked Questions")]),_c('p',{staticClass:"subtitle"},[_vm._v("Answers to the questions we hear most often during a case review.")])])
}]

export { render, staticRenderFns }